import { ChainId, TokenAmount } from '@pancakeswap/sdk'
import React, { useState } from 'react'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'
import { darken } from 'polished'

import styled from 'styled-components'

import Logo from '../../assets/images/logotypes/moonie-nft.svg'
import Mny from '../../assets/images/mny.png'

import { useActiveWeb3React } from '../../hooks'
import { useAggregateUniBalance, useETHBalances } from '../../state/wallet/hooks'
import { CardNoise } from '../earn/styled'
import { CountUp } from 'use-count-up'
import { ExternalLink, TYPE } from '../../theme'

import { YellowCard } from '../Card'

import Row, { RowFixed } from '../Row'
import Web3Status from '../Web3Status'
import ClaimModal from '../claim/ClaimModal'
import { useShowClaimPopup, useToggleSelfClaimModal } from '../../state/application/hooks'
import { useUserHasAvailableClaim } from '../../state/claim/hooks'
import { useUserHasSubmittedClaim } from '../../state/transactions/hooks'
import { Dots } from '../swap/styleds'
import Modal from '../Modal'
import UniBalanceContent from './UniBalanceContent'
import usePrevious from '../../hooks/usePrevious'

const HeaderFrame = styled.div`
  display: grid;
  grid-template-columns: 1fr 120px;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  top: 0;
  position: relative;
  border-bottom: 1px solid #fcd535;
  padding: 1rem;
  z-index: 2;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    grid-template-columns: 1fr;
    padding: 0 1rem;
    width: calc(100%);
    position: relative;
  `};

  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
        padding: 0.5rem 1rem;
  `}
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-self: flex-end;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
    justify-content: space-between;
    justify-self: center;
    width: 100%;
    max-width: 960px;
    padding: 1rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 99;
    height: 72px;
    border-radius: 12px 12px 0 0;
    background-color: ${({ theme }) => theme.bg1};
  `};
`

const HeaderElement = styled.div`
  display: flex;
  align-items: center;

  /* addresses safari's lack of support for "gap" */
  & > *:not(:first-child) {
    margin-left: 8px;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
   flex-direction: row-reverse;
    align-items: center;
  `};
`

/*const HeaderElementWrap = styled.div`
  display: flex;
  align-items: center;
`*/

const HeaderRow = styled(RowFixed)`
  ${({ theme }) => theme.mediaWidth.upToMedium`
   width: 100%;
  `};
`

const HeaderLinks = styled(Row)`
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 2rem 0 1rem 1rem;
    justify-content: flex-end;
`};
`

const AccountElement = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme, active }) => (!active ? theme.bg1 : theme.bg3)};
  border-radius: 12px;
  white-space: nowrap;
  width: 100%;
  cursor: pointer;

  :focus {
    border: 1px solid blue;
  }
`

const VAIAmount = styled(AccountElement)`
  color: ${({ theme }) => theme.text1};
  padding: 4px 8px;
  height: 36px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.bg3};
  background: linear-gradient(6deg, #000, #181818);
  border: 1px solid;
`

const VAIWrapper = styled.span`
  width: fit-content;
  position: relative;
  cursor: pointer;

  :hover {
    opacity: 0.8;
  }

  :active {
    opacity: 0.9;
  }
`

const HideSmall = styled.span`
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

const NetworkCard = styled(YellowCard)`
  border-radius: 12px;
  padding: 8px 12px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin: 0;
    margin-right: 0.5rem;
    width: initial;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  `};
`

const BalanceText = styled(Text)`
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: none;
  `};
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  justify-self: flex-start;
  margin-right: 40px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    justify-self: center;
  `};
  :hover {
    cursor: pointer;
  }
`

const UniIcon = styled.div`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`

const activeClassName = 'ACTIVE'

const StyledNavLink = styled(NavLink).attrs({
  activeClassName
})`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 0.9rem;
  width: 180px;
  margin: 0 12px;
  font-weight: 500;

  &.${activeClassName} {
    border-radius: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.text1};
  }

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }
`

/*const TmpNavLink = styled.div`
  ${({ theme }) => theme.flexRowNoWrap}
  align-items: left;
  border-radius: 3rem;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 0.9rem;
  width: fit-content;
  margin: 0 2px;
  font-weight: 500;
`

const ComingSoon = styled.span`
background-color rgb(121 99 172);
border-radius 10px;
box-sizing border-box;
color rgb(255, 255, 255);
display inline-block;
font-size 12px;
font-weight 700;
height 18px;
line-height 12px;
padding-bottom 3px;
padding-left 4.8px;
padding-right 4.8px;
padding-top 3px;
text-align center;
text-size-adjust 100%;
vertical-align baseline;
white-space nowrap;
`*/

export const StyledMenuButton = styled.button`
  position: relative;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  height: 35px;
  background-color: ${({ theme }) => theme.bg3};
  margin-left: 8px;
  padding: 0.15rem 0.5rem;
  border-radius: 0.5rem;

  :hover,
  :focus {
    cursor: pointer;
    outline: none;
    background-color: ${({ theme }) => theme.bg4};
  }

  svg {
    margin-top: 2px;
  }
  > * {
    stroke: ${({ theme }) => theme.text1};
  }
`

const NETWORK_LABELS: { [chainId in ChainId]?: string } = {
  [ChainId.MAINNET]: 'MAINNET',
  [ChainId.TESTNET]: 'TESTNET'
}

export default function Header() {
  const { account, chainId } = useActiveWeb3React()
  //   const { account } = useActiveWeb3React()

  const userEthBalance = useETHBalances(account ? [account] : [])?.[account ?? '']
  // const [isDark] = useDarkModeManager()
  // const [darkMode, toggleDarkMode] = useDarkModeManager()

  // const darkMode = true

  const toggleClaimModal = useToggleSelfClaimModal()

  const availableClaim: boolean = useUserHasAvailableClaim(account)

  const { claimTxn } = useUserHasSubmittedClaim(account ?? undefined)

  const aggregateBalance: TokenAmount | undefined = useAggregateUniBalance()

  const [showUniBalanceModal, setShowUniBalanceModal] = useState(false)
  const showClaimPopup = useShowClaimPopup()

  const countUpValue = aggregateBalance?.toFixed(0) ?? '0'
  const countUpValuePrevious = usePrevious(countUpValue) ?? '0'

  return (
    <HeaderFrame className="c-stakingHeader_wrapper">
      <ClaimModal />
      <Modal isOpen={showUniBalanceModal} onDismiss={() => setShowUniBalanceModal(false)} cls="balance">
        <UniBalanceContent setShowUniBalanceModal={setShowUniBalanceModal} />
      </Modal>
      <HeaderRow>
        <Title href="https://moonie.io" className="c-stakingHeader_logo">
          <UniIcon>
            <img src={Logo} alt="logo" />
          </UniIcon>
        </Title>
        <HeaderLinks className="c-stakingHeader_links">
          <ExternalLink
            id={`eth-stake-nav-link`}
            href={'https://staking-eth.moonie.io/'}
            target={'_blank'}
            className="c-stakingHeader_link"
          >
            Eth Liquidity Staking
          </ExternalLink>
          <StyledNavLink id={`stake-nav-link`} to={'/stake'} className="c-stakingHeader_link ACTIVE">
            BSC Liquidity Staking
          </StyledNavLink>
        </HeaderLinks>
        {/* <HeaderLinks> */}
        {/*          <StyledNavLink id={`pre-stake-nav-link`} to={'/prestake'}>
            Pre-Staking
          </StyledNavLink>*/}
        {/*          <TmpNavLink id={`pre-stake-nav-link`}>Pre-Staking</TmpNavLink>
          <ComingSoon>Coming soon!</ComingSoon>*/}
        {/* </HeaderLinks> */}
      </HeaderRow>
      <HeaderControls className="c-stakingHeader_controls">
        <HeaderElement>
          <HideSmall>
            {chainId && NETWORK_LABELS[chainId] && (
              <NetworkCard title={NETWORK_LABELS[chainId]} className="c-stakingHeader_chainId">
                {NETWORK_LABELS[chainId]}
              </NetworkCard>
            )}
          </HideSmall>
          {availableClaim && !showClaimPopup && (
            <VAIWrapper onClick={toggleClaimModal}>
              <VAIAmount active={!!account && !availableClaim} style={{ pointerEvents: 'auto' }}>
                <TYPE.white padding="0 2px">
                  {claimTxn && !claimTxn?.receipt ? <Dots>Claiming MNY</Dots> : 'Claim MNY'}
                </TYPE.white>
              </VAIAmount>
              <CardNoise />
            </VAIWrapper>
          )}
          {!availableClaim && aggregateBalance && (
            <VAIWrapper onClick={() => setShowUniBalanceModal(true)} className="c-stakingHeader_mnyWrapper">
              <VAIAmount
                active={!!account && !availableClaim}
                style={{ pointerEvents: 'auto' }}
                className="c-stakingHeader_coin"
              >
                {account && (
                  <HideSmall>
                    <TYPE.white className="c-stakingHeader_mnyBalance">
                      <CountUp
                        key={countUpValue}
                        isCounting
                        start={parseFloat(countUpValuePrevious)}
                        end={parseFloat(countUpValue)}
                        thousandsSeparator={','}
                        duration={1}
                      />
                    </TYPE.white>
                  </HideSmall>
                )}
                <img src={Mny} alt="logo" />
              </VAIAmount>
              {/* <CardNoise /> */}
            </VAIWrapper>
          )}
          <AccountElement active={!!account} className="c-stakingHeader_connectWrapper">
            {account && userEthBalance ? (
              <BalanceText className="c-stakingHeader_balance">{userEthBalance?.toSignificant(4)} BNB</BalanceText>
            ) : null}
            <Web3Status />
          </AccountElement>
        </HeaderElement>
        {/*        <HeaderElementWrap>
          <StyledMenuButton onClick={() => toggleDarkMode()}>
            {darkMode ? <Moon size={20} /> : <Sun size={20} />}
          </StyledMenuButton>
          <Menu />
        </HeaderElementWrap>*/}
      </HeaderControls>
    </HeaderFrame>
  )
}
